import axios from 'axios';

export default async function getUserLocations({
  accessToken,
  userId,
  companyId = 0,
  page = 0,
  pageSize = 10,
  query = '',
  setTokenLikeExpired,
}) {
  const requestOptions = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_LOCATIONS_API_URL}/user-locations/${userId}?page=${page}&pageSize=${pageSize}&query=${query}&companyId=${companyId}`,
      requestOptions,
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return null;
  }
}
